module.exports = __webpack_public_path__ + "img/arrow_left_white.78420b90.svg";